import React, { FC } from 'react';
import classNames from 'classnames';
import { TypeBackgroundColorFields } from '@/core/generated-types';

interface AdditionalProps {
  applyGutters?: boolean;
  classes?: string;
  children?: React.ReactNode;
}

export interface BackgroundColorWrapperProps
  extends TypeBackgroundColorFields,
    AdditionalProps {}

const BackgroundColorWrapper: FC<BackgroundColorWrapperProps> = ({
  color,
  applyGutters = false,
  classes,
  children,
}) => {
  if (!color) {
    return <div className={classNames(classes)}>{children}</div>;
  }

  const shouldIncludeWrapperWithClasses = applyGutters || classes;

  if (shouldIncludeWrapperWithClasses) {
    const allClasses = classNames(classes, {
      'mx-auto': applyGutters,
    });

    return (
      <div
        className={`bg-${color}`}
        data-testid="bg-color-wrapper-custom-styles-variant"
      >
        <div className={allClasses}>{children}</div>
      </div>
    );
  }

  return (
    <div
      className={`bg-${color}`}
      data-testid="bg-color-wrapper-default-variant"
    >
      {children}
    </div>
  );
};

export default BackgroundColorWrapper;
